module.exports = __webpack_public_path__ + "static/media/videoCatcar.62545dca.mp4";